import { IActivityEntity } from '../entitites/activity.entity';

export class ActivityDto {
  readonly title: string;
  readonly message: string;
  readonly date: Date;
  readonly type: string;
  readonly icon: string;
  readonly content: string;

  constructor(activity: IActivityEntity) {
    this.title = activity.title;
    this.message = activity.message;
    this.date = new Date(activity.datetime);
    this.type = activity.type;
    this.icon = activity.icon;
    this.content = activity.content;
  }
}
